document.querySelectorAll('.program-toggle').forEach(button => {
  button.addEventListener('click', () => {
    let container = button.parentNode;
    let items = container.querySelectorAll('.schauburg-program-list-item');
    const isExpanded = button.classList.contains('expanded');

    if (isExpanded) {
      // collapse back → hide all except first two
      items.forEach((item, index) => {
        if (index > 1) {
          item.classList.remove('active');
          item.classList.add('hidden');
        }
      });
      button.classList.remove('expanded');
      container.scrollIntoView()
      button.textContent = 'ganze woche zeigen';
    } else {
      // expand → show all
      items.forEach(item => {
        item.classList.remove('hidden');
        item.classList.add('active');
      });
      button.classList.add('expanded');
      button.textContent = 'nur heute und morgen zeigen';
    }
  });
});
